import { render, staticRenderFns } from "./GlossaryCultures.vue?vue&type=template&id=50ccd7cf&"
import script from "./GlossaryCultures.vue?vue&type=script&lang=js&"
export * from "./GlossaryCultures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports